import React, { Fragment } from "react";
import PropTypes from "prop-types";

import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const ConfirmModal = props => {
    const { title, content, isOpen, onConfirm, onCancel, isErrorModal, confirmText, cancelText, isHeaderDanger = false, isCloseBtn = true } = props;

    const closeBtn = (
        <button className="close" onClick={onCancel}>
            &times;
        </button>
    );

    const className = () => {
        if(isErrorModal) return "text-danger";
        if(isHeaderDanger) return "modal-header--danger";
        return "";
    };

    return (
        <Modal isOpen={isOpen} centered>
            {title && (
                <ModalHeader 
                    className={className()}
                    close={isCloseBtn && closeBtn}>
                    {title}
                </ModalHeader>
            )}

            <ModalBody>{content}</ModalBody>

            <ModalFooter>
                {isErrorModal ? (
                    <Button color="danger" onClick={onConfirm}>
                        {confirmText || 'Ok'}
                    </Button>
                ) : (
                    <Fragment>
                        <Button color="success" onClick={onConfirm}>
                            {confirmText || 'Sim'}
                        </Button>
                        <Button color="danger" onClick={onCancel}>
                            {cancelText || 'Não'}
                        </Button>
                    </Fragment>
                )}
            </ModalFooter>
        </Modal>
    );
};

ConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    content: PropTypes.string.isRequired,
    title: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isErrorModal: PropTypes.bool,
    isCloseBtn: PropTypes.bool,
    isHeaderDanger: PropTypes.bool,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
};

export { ConfirmModal }
